import mixpanel from 'mixpanel-browser'

if (import.meta.env.VITE_MIXPANEL === 'on') {
    mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN)
}

export default mixpanel
